import axios from "axios";
import config from "./config";
export default {
    async createUser(user) {
        try {
            let { data: c } = await axios.post(config.openkit_url == undefined ? "" : config.openkit_url + "users", user);
            return c;
        }
        catch (error) {
            return null;
        }
    },
    async confirmEmail(id) {
        try {
            let { data: c } = await axios.post(config.openkit_url == undefined
                ? ""
                : config.openkit_url + "users/confirm-email/" + id);
            return c;
        }
        catch (error) {
            return null;
        }
    },
};
